import {makeAutoObservable} from "mobx";
import RmaFeeStore from "./rma-fee-store";
import { ICRMAFeeDto } from "../../../models/User";

class RmaFeesListStore {
	private _returnFee: RmaFeeStore;
	private _labelFee: RmaFeeStore;

	/**
	 * @param returnSeed labelSeed optional API rows (god mode: create-RMA options defaults). Omitted = blank until policy-led fills or god seeds passed.
	 */
	constructor(returnSeed?: ICRMAFeeDto, labelSeed?: ICRMAFeeDto) {
		makeAutoObservable(this);
		this._returnFee = new RmaFeeStore(returnSeed);
		this._labelFee = new RmaFeeStore(labelSeed);
	}

	get returnFee() { return this._returnFee; }
	get labelFee() { return this._labelFee; }
}

export default RmaFeesListStore;
